var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"qoo-main"},[_c('div',{staticClass:"container-fluid p-0"},[_c('router-view')],1),_c('OverlayLoader',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }